import { render } from "./index.vue?vue&type=template&id=4960d1bc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/callback/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4960d1bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4960d1bc', __exports__)) {
    console.log('reload')
    api.reload('4960d1bc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4960d1bc", () => {
    console.log('re-render')
    api.rerender('4960d1bc', render)
  })

}


export default __exports__